exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#capital-filter{width:80%;margin:32px auto 0}#capital-filter button{padding:0;height:32px;width:32px;font-size:1.2rem;border-radius:0;margin:4px 12px}#capital-filter button.chosen{background-color:#00adb5;color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.3)}#capital-filter button.unchosen{background-color:#fff;color:#00adb5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38565db6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CapitalFilter.vue
// module id = 511
// module chunks = 0